export default __webpack_public_path__ + "static/media/icon-info.9e38fd64.svg";